module.exports = "<i class=glyphicon ng-class=\"'glyphicon-' + icon\"> <span class=sr-only></span> </i> ";